<template>
    <div id="modals-box"></div>

    <template v-for="item in openedModals" :key="item.name">
        <template v-if="modalsComponents[item.name]">
            <component :is="modalsComponents[item.name]" :name="item.name" />
        </template>
    </template>
</template>

<script setup>
import { computed, onBeforeUnmount, defineAsyncComponent } from 'vue';

import ModalAuth from './ModalAuth.vue';
import ModalLoader from './ModalLoader.vue';

import { storeToRefs } from 'pinia';
// import stores from '@/stores';
const modals = stores.modals();

const { openedModals, confirmSettings, modalsComponents } = storeToRefs(modals);

const items = {
    auth: ModalAuth,
    loader: ModalLoader
};

modals.register(items);

onBeforeUnmount(() => {
    modals.unRegister(Object.keys(items));
});
</script>

<style scoped lang="scss">
    #modals-box {
        position: fixed;
        z-index: 2;
    }
</style>
